<template>
    <section class="section section-shaped section-lg my-0"
             :style="oracle.isMobile() ? '' : 'border-top: inset 150px transparent; box-sizing: border-box;background: url(' + require('@/assets/image/globes.png') + ') top '+(isEN ?'right' : 'left')+' no-repeat'">
        <div class="shape shape-style-1 shape-default shape-skew response bg-gradient">
        </div>
        <RegisterComponent :style="!oracle.isMobile() ? 'margin-top: -150px' : 'margin-top: -100px'"
                           :authenticate="true"
                           :lambda-done="()=>{this.$router.push('/accounts')}">
        </RegisterComponent>
    </section>
</template>
<script>

    import RegisterComponent from "@/views/profile/Authenticator";
    import oracle from "@/utils/oracle";

    export default {
        name: "Register",
        components: {RegisterComponent},
        data: () => ({
            isEN: oracle.isEN(),
            oracle: oracle
        }), mounted() {
        }
    };
</script>
<style>
</style>
